module.exports = __webpack_public_path__ + "img/Comic05-1.9c519b95.png";